module.exports = __webpack_public_path__ + "img/accueil-portrait-thumbnail.2d8b17de.jpg";